import { useEffect } from 'react';
import Button from '../ui/Button.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Result = ({ ...props }) => {
    const { heading, image, action, fn, feedback } = props;

    useEffect(() => {
        const [actionName, actionValue] = action.split(':');
        if ('onload.send' === actionName) {
            fn.handleSend(actionValue);
        }
    }, []);

    return (
        <div className="component-message">
            <div className="row justify-center">
                <div className="col lg:w-8/12 xl:w-6/12">
                    <div className="text-center">
                        <HeadingOne heading={feedback?.heading ?? heading} />
                        <img src={image} className="mx-auto" />
                        <h2 className="mt-12">{feedback?.title ?? ''}</h2>
                        <div dangerouslySetInnerHTML={{ __html: feedback?.message ?? '' }}></div>

                        <div className="mt-12">
                            <Button type="white" onClick={() => fn.handleAction(feedback?.action)}>
                                Pokračuj
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Result;
